<template>
    <v-container fluid>
        <v-layout column justify-center>
            <v-container fluid>
                <v-layout column align-center>
                    <img
                        class="jusda-logo"
                        src="../assets/JusdaWhite.png"
                        alt="Jusda Logo"
                        @click="redirectToJusda"
                    />
                    <h1 class="display-1 text-xs-center heading">
                        Search the Section 301 Lists
                    </h1>
                    <strong
                        v-if="error"
                        class="font-weight-bold text-xs-center error-message"
                    >{{error}}</strong>
                    <v-layout
                        :row="$vuetify.breakpoint.smOnly"
                        :column="$vuetify.breakpoint.xsOnly"
                        class="htsInputWrapper"
                    >
                        <v-text-field
                            :dark="true"
                            label="HTS Number ####.##.####"
                            :clearable="true"
                            :hide-details="true"
                            v-model="query"
                        />
                        <v-btn
                            @click="fetchSection301List"
                            :dark="true"
                            color="grey darken-4"
                            large
                        >Search</v-btn>
                    </v-layout>
                    <strong class="text-xs-center search-note">
                        Partial HTS Searches Allowed
                    </strong>
                </v-layout>
            </v-container>
            <v-data-table
                :headers="headers"
                :items="items"
                :loading="loading"
                :dark="true"
                class="elevation-1"
            >
                <v-progress-linear
                    slot="progress"
                    color="blue"
                    :indeterminate="true"
                />
                <template v-slot:item.dutyRate="{ item }">
                    {{ renderRates(item.dutyRate) }}
                </template>
                <template v-slot:item.exclusions="{ item }">
                    <v-btn v-if="item.exclusions.length > 0" @click="hydrateExclusions(item.exclusions)">
                        View
                    </v-btn>
                    <template v-else>None</template>
                </template>
                <template v-slot:item.subscribe="{ item }">
                    <v-btn @click="toggleSubscribeDialog(item.htsNo)">
                        Subscribe
                    </v-btn>
                </template>
            </v-data-table>
        </v-layout>
        <v-dialog v-model="exclusionsDialog">
            <v-card>
                <v-card-title>Exclusions</v-card-title>
                <v-card-text>
                    <v-data-table
                        :headers="exclusionsTableHeaders"
                        :items="exclusions"
                        :dark="true"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="toggleExclusionsDialog()"
                    >Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="subscribeDialog">
            <v-card>
                <v-card-title>Subscribe</v-card-title>
                <v-card-text>
                    <p v-if="subscribeError">
                        Error: {{ subscribeError }}
                    </p>
                    <v-text-field
                        v-model="subscribeHTSNumber"
                        label="HTS Number"
                        readonly
                    />
                    <v-text-field
                        label="Email"
                        v-model="subscribeEmail"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="subscribeHTS()"
                    >Save</v-btn>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="toggleSubscribeDialog()"
                    >Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
export default {
    name: 'Section301List',
    mounted() {
        // This is to apply a breakpoint to change layout from row to column
        this.onResize();
        window.addEventListener(
            'resize',
            this.onResize,
            {passive: true}
        );
    },
    beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener(
                'resize',
                this.onResize,
                {passive: true}
            );
        }
    },
    methods: {
        async fetchSection301List() {
            // Fetch a user's IP
            await this.fetchUserIP();

            // Check for query string
            if (this.query) {
                // Initialize loading animation and wipe any remaining error messages
                await this.toggleLoading();
                await this.hydrateError();

                // Attempt request
                try {
                    const response = await fetch(`${this.api}${this.query}&ipAddress=${this.userIP}`);

                    // Show data or error depending on returned status
                    switch(response.status) {
                        case 200: {
                            const data = await response.json();
                            await this.hydrateItems(data);
                            break;
                        }
                        case 400: {
                            const error400 = await response.json();
                            await this.hydrateError(error400);
                            break;
                        }
                        case 500: {
                            const error500 = await response.json();
                            await this.hydrateError(error500);
                            break;
                        }
                    }
                } catch (err) {
                    // In case of any exceptions
                    await this.hydrateError('Something went wrong');
                }

                // End loading animation
                await this.toggleLoading();
            }
        },
        async fetchUserIP() {
            try {
                const response = await fetch('https://api.ipify.org/?format=json');
                const data = await response.json();
                this.userIP = await data.ip;
            } catch (err) {
                await this.hydrateError('Something went wrong');
            }
        },
        hydrateError(error = null) {
            if (error) {
                this.error = error.error
                this.items = [];
            } else {
                this.error = null;
            }
        },
        toggleLoading() {
            this.loading = !this.loading
        },
        hydrateItems(fetchedItems = []) {
            if (Array.isArray(fetchedItems)) {
                this.items = [...fetchedItems];
            }
        },
        renderRates: (rate = 0) => String(rate * 100) + '%',
        onResize() {
            this.isMobile = window.innerWidth < 600;
        },
        redirectToJusda: () => window.location = 'https://jusdausa.com/',
        hydrateExclusions(exclusions = []) {
            if (Array.isArray(exclusions)) {
                this.exclusions = [...exclusions];
                this.toggleExclusionsDialog();
            }
        },
        async subscribeHTS() {
            this.subscribeError = null;
            // POST email to endpoint
            const testEmailString = RegExp(/\S+@\S+/); // Checks to see if string has '@'

            if (testEmailString.test(this.subscribeEmail)) {
                try {
                    const requestObject = {
                        method: 'POST',
                        cors: 'no-cors',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            emailAddress: this.subscribeEmail,
                            htsNo: this.subscribeHTSNumber,
                        }),
                    };
                    const response = await fetch('https://jusda.azurewebsites.net/api/hts/Section301/subscribe', requestObject);

                    console.log({ response });
                    if (response.status === 200) {
                        this.subscribeDialog = !this.subscribeDialog;
                    } else {
                        this.subscribeError = 'Something went wrong';
                    }
                } catch(err) {
                    console.error({ err });
                }
            } else {
                this.subscribeError = 'Not a valid email';
            }
        },
        toggleExclusionsDialog() {
            this.exclusionsDialog = !this.exclusionsDialog;
        },
        toggleSubscribeDialog(htsNo) {
            this.subscribeHTSNumber = htsNo;
            this.subscribeDialog = !this.subscribeDialog;
        },
    },
    data: () => ({
        api: 'https://jusda.azurewebsites.net/api/Hts/Section301?htsNo=',
        userIP: '',
        loading: false,
        isMobile: false,
        exclusionsDialog: false,
        subscribeDialog: false,
        subscribeHTSNumber: '',
        subscribeEmail: '',
        subscribeError: null,
        exclusions: [],
        query: null,
        error: null,
        items: [],
        exclusionsTableHeaders: [
            {
                text: 'Expiration Date',
                align: 'left',
                sortable: true,
                value: 'expirationDate',
            },
            {
                text: 'Granted Date',
                align: 'left',
                sortable: true,
                value: 'grantedDate',
            },
            {
                text: 'Product Description',
                align: 'left',
                sortable: true,
                value: 'productDescription',
            },
        ],
        headers: [
            {
                text: 'HTS No',
                align: 'left',
                sortable: true,
                value: 'htsNo',
            },
            {
                text: 'HTS Description',
                align: 'left',
                sortable: false,
                value: 'htsDescription',
            },
            {
                text: 'Section 301 Class',
                align: 'left',
                sortable: true,
                value: 'section301Classification',
            },
            {
                text: 'Section 301 Description',
                align: 'left',
                sortable: false,
                value: 'section301Description',
            },
            {
                text: 'Add On Duty Rate',
                align: 'left',
                sortable: true,
                value: 'dutyRate',
            },
            {
                text: 'Exclusions',
                align: 'center',
                sortable: false,
                value: 'exclusions',
            },
            {
                text: 'Subscribe',
                align: 'center',
                sortable: false,
                value: 'subscribe',
            },
        ],
    }),
}
</script>
<style scoped>
.error-message {
    color: #D32F2F;
}

.error-message,
.search-note {
    margin: 10px 0;
}

.jusda-logo {
    height: 60px;
    cursor: pointer;
}

.jusda-logo,
.heading {
    margin-bottom: 10px;
}

.htsInputWrapper {
    width: 425px;
}

.heading,
.search-note {
    color: #FFFFFF;
}

@media screen and (max-width: 600px) {
    .htsInputWrapper {
        width: 100%;
    }
}
</style>